import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static targets = ["element"];
  static values = {
    labels: Array,
    series: Array,
    control: Number,
    variable: Number,
  };

  connect() {
    window.HSStaticMethods.autoInit();
    var options = {
      series: this.seriesValue,
      labels: this.labelsValue,
      chart: {
        height: 197,
        type: "donut",
      },
      dataLabels: {
        enabled: false,
        dropShadow: {
          enabled: false,
        },
      },
      legend: {
        show: false,
      },
      stroke: {
        width: 0,
      },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: "80%",
            background: "transparent",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "20px",
                color: "#495057",
                fontFamily: "Montserrat, sans-serif",
                offsetY: -5,
              },
              value: {
                show: true,
                fontSize: "22px",
                color: undefined,
                offsetY: 5,
                fontWeight: 600,
                fontFamily: "Montserrat, sans-serif",
                formatter: function (val) {
                  return val + "%";
                },
              },
              total: {
                show: true,
                showAlways: true,
                label: "Performance",
                fontSize: "14px",
                fontWeight: 400,
                color: "#495057",
                formatter: (w) => {
                  let percentage = (
                    (this.controlValue /
                      (this.controlValue + this.variableValue)) *
                    100
                  ).toFixed(2);

                  if (isNaN(percentage)) {
                    percentage = 0;
                  }

                  return percentage + "%";
                },
              },
            },
          },
        },
      },
      colors: [
        "rgba(var(--primary-rgb))",
        "rgba(255, 90, 41, 1)",
        "rgba(12, 199, 99, 1)",
        "rgba(12, 156, 252, 1)",
        "rgba(255, 154, 19, 1)",
      ],
    };
    var chart1 = new ApexCharts(this.elementTarget, options);

    chart1.render();
  }
}
